<template>
  <div class="checkout-generic-error checkout-feedback-screen flow-step">
    <h1>Algo inesperado aconteceu</h1>
    <img src="@/assets/junior-error.png" alt />
    <p>
      Sentimos muito, o cupom usado não está mais disponível!
    </p>
    <span>
      O cupom passado tinha um limite de usos ou de tempo que foi excedido.
    </span>
  </div>
</template>

<script>
export default {
  name: 'checkout-coupon-error'
}
</script>
